
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import BaseLogic from "@/logic/base_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RemoteResult from "@/entities/common/remote_result"
import FilialeLiefergebietResult from "@/entities/common/filiale_liefergebiet_result"
import IdStringRequest from "@/entities/common/request/id_string_request"
import Validator from "@/util/validator"
import vuexStore from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"

@Component({ components: { FilialeHeader, NichtGueltig } })
export default class StandortLieferungPlz extends mixins(Calculator) {
  logic: StandortLieferungPlzLogic = null
  plzRules = Validator.plzValidate

  mounted() {
    this.logic = new StandortLieferungPlzLogic()
  }

  postleitzahlPruefen() {
    this.logic.postleitzahlPruefen()
  }

  postleitzahlBestaetigen() {
    this.logic.postleitzahlBestaetigen()
  }
}

class StandortLieferungPlzLogic extends BaseLogic {
  standortPlz: string
  standortNichtGefunden: boolean = false
  standortGefunden: boolean = false

  lieferkosten: number
  lieferzeit: string
  mindestbestellwert: number
  kostenlosAb: number

  postleitzahlBestaetigen() {
    var request = new IdStringRequest()
    request.id = vuexStore.state.user.identifier
    request.param = this.standortPlz

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingStandortPlzFestlegen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending.lieferung.kundePlz = this.standortPlz
        this.mainLogic.bestellungPending.lieferung.lieferkosten =
          this.lieferkosten
        this.mainLogic.bestellungPending.lieferung.mindestbestellwert =
          this.mindestbestellwert
        this.mainLogic.bestellungPending.lieferung.kostenlosAb =
          this.kostenlosAb
        router.push({ name: RouteNames.NEU.TERMIN_LIEFERUNG })
      }
    })
  }

  postleitzahlPruefen() {
    this.standortNichtGefunden = false
    this.standortGefunden = false

    var request = new IdStringRequest()
    request.id = this.filiale.filialeId
    request.param = this.standortPlz

    Poster.postUser<RemoteResult<FilialeLiefergebietResult>>(
      RestPaths.bestellungpendingStandortPruefenPlz,
      request,
    ).then((response) => {
      if (response.data.success) {
        var payload = response.data.payload

        if (payload != null) {
          this.lieferkosten = payload.lieferkosten
          this.lieferzeit = payload.lieferzeit
          this.mindestbestellwert = payload.mindestbestellwert
          this.kostenlosAb = payload.kostenlosAb
          this.standortGefunden = true
        } else {
          this.standortNichtGefunden = true
        }
      }
    })
  }
}
